import { api } from "./api";
import { pickHqBrandingLogo } from "../../admin-shared/hqOrgBrandingLogo";
import {
  persistOrgLogo,
  resolveMediaUrl,
  resolvePartnerLogoSrc,
} from "./mediaUrl";

function pickLogoUrl(...candidates) {
  for (const raw of candidates) {
    if (!raw) continue;
    const resolved =
      resolveMediaUrl(raw) ||
      (typeof raw === "string" &&
      (raw.startsWith("http://") || raw.startsWith("https://") || raw.startsWith("data:"))
        ? raw
        : null);
    if (resolved) return resolved;
  }
  return null;
}

/**
 * Load organization logo for HQ portals. Uses portal-scoped api() so the
 * access cookie is selected correctly on refresh.
 */
export async function fetchOrganizationLogo({ isFranchise = false } = {}) {
  const tryJson = async (path) => {
    try {
      const res = await api(path);
      if (!res.ok) return null;
      return await res.json();
    } catch (_) {
      return null;
    }
  };

  const brandingData = await tryJson("/organization/branding");
  if (brandingData?.branding) {
    const raw = pickHqBrandingLogo(brandingData.branding, { isFranchise });
    const chosen = pickLogoUrl(raw);
    if (chosen) {
      persistOrgLogo(chosen);
      return chosen;
    }
  }

  if (isFranchise) {
    return resolvePartnerLogoSrc(null);
  }

  const pageSetup = await tryJson("/flow/page-setup");
  const fromPageSetup = pickLogoUrl(
    pageSetup?.external_fields?.org_logo,
    pageSetup?.org_logo
  );
  if (fromPageSetup) {
    persistOrgLogo(fromPageSetup);
    return fromPageSetup;
  }

  const company = await tryJson("/company-profile");
  const fromCompany = pickLogoUrl(company?.profile?.logo_url, company?.profile?.org_logo);
  if (fromCompany) {
    persistOrgLogo(fromCompany);
    return fromCompany;
  }

  return null;
}
